export default "__VITE_ASSET__Dq1ZN6EG__"